module.exports = __webpack_public_path__ + "static/media/property-img.7d2e2bf9.jpg";